import { computed, Injectable } from '@angular/core';
import { CaseBattleService } from '@features/case-battles/case-battles.service';
import { CoinflipService } from '@features/coinflip/coinflip.service';
import { JackpotService } from '@features/jackpot/jackpot.service';
import { KingService } from '@features/king/king.service';
import { IconsEnum } from '@models/icons.interface';
import { NavigationItem } from '@models/navigation';
import { UIService } from '@shared/ui.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  readonly MAIN: NavigationItem[] = [
    {
      route: '/',
      title: 'home',
      icon: IconsEnum.home,
      hasHoverState: true,
    },
    {
      title: 'wallet',
      icon: IconsEnum.wallet,
      hasHoverState: true,
    },
  ];

  readonly games = computed<NavigationItem[]>(() => [
    {
      route: '/battles',
      title: 'case battles',
      icon: IconsEnum.case_battles,
      value: `${Math.round(this.caseBattleService.totalValue() * 100) / 100}`,
      hasHoverState: true,
    },
    {
      route: '/coinflip',
      title: 'coinflip',
      icon: IconsEnum.coinflip,
      value: `${this.coinflipService.totalValue()}`,
      hasHoverState: true,
    },
    {
      route: '/king',
      title: 'king',
      icon: IconsEnum.king,
      value: `${Math.round((this.kingService.king()?.king?.value ?? 0) * 100) / 100} `,
      hasHoverState: true,
    },
    {
      route: '/jackpot',
      title: 'jackpot',
      icon: IconsEnum.jackpot,
      value: `${Math.round(this.jackpotService.totalValue() * 100) / 100}`,
      hasHoverState: true,
    },
    {
      route: '/cases',
      title: 'case opening',
      icon: IconsEnum.case_opening,
      hasHoverState: true,
    },
    {
      route: '/plinko',
      title: 'plinko',
      icon: IconsEnum.plinko,
      hasHoverState: true,
    },
    {
      route: '/mines',
      title: 'mines',
      icon: IconsEnum.mines,
      hasHoverState: true,
    },
    {
      route: '/towers',
      title: 'towers',
      icon: IconsEnum.towers,
      hasHoverState: true,
    },
  ]);

  readonly FEATURES: NavigationItem[] = [
    {
      route: '/raffles',
      title: 'raffles',
      icon: IconsEnum.raffles,
      highlighted: true,
      value: '5000',
      hasHoverState: true,
    },
    {
      route: '/leaderboard',
      title: 'leaderboard',
      icon: IconsEnum.leaderboard,
      highlighted: true,
      value: '5000',
      hasHoverState: true,
    },
    {
      route: '/rewards',
      title: 'rewards',
      icon: IconsEnum.rewards,
      highlighted: true,
      dot: true,
      highlightText: true,
    },
    // {
    //   route: '/affiliates',
    //   title: 'affiliates',
    //   icon: IconsEnum.backpack,
    // },
    // {
    //   route: '/website-promotion',
    //   title: 'website promotion',
    //   icon: IconsEnum.backpack,
    // },
  ];

  readonly MAINTENANCE: NavigationItem[] = [
    // {
    //   route: '/tos',
    //   title: 'ToS',
    //   icon: IconsEnum.tos,
    //   hasHoverState: true,
    // },
    // {
    //   route: '/faq',
    //   title: 'FAQ',
    //   icon: IconsEnum.faq,
    //   hasHoverState: true,
    // },
    {
      title: 'support',
      icon: IconsEnum.support,
      hasHoverState: true,
    },
    {
      route: '/provably-fair',
      title: 'Fairness',
      icon: IconsEnum.fairness,
      hasHoverState: true,
    },
  ];

  constructor(
    public uiService: UIService,
    private coinflipService: CoinflipService,
    private caseBattleService: CaseBattleService,
    private kingService: KingService,
    private jackpotService: JackpotService,
  ) {}
}
